import React from 'react';
import { languageController } from '../../../../controllers/language/languageController';
import CalloutBoxShort from '../../../2_Molecules/CalloutBox/CalloutBoxShort';
import { VehicleData, DealerData, DateAndTimeData, ContactDetails } from '../BookServiceAppointment';

interface ConfirmationStepProps {
  contactDetails?: ContactDetails;
  vehicleData?: VehicleData;
  dealerData?: DealerData;
  dateAndTimeData?: DateAndTimeData;
}

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  contactDetails,
  vehicleData,
  dealerData,
  dateAndTimeData
}) => {
  const { dealer, userPosition } = dealerData || {};

  return (
    <div className="mz-confirmation-step-basa">
      <div className="mz-container">
        <div className="grid-inner-content-wide mz-confirmation-step-basa__top">
          <h3>{languageController.getCopy('confirmationStep', 'title')}, {contactDetails?.firstname}!</h3>
          <p className="m-b-0">{languageController.getCopy('confirmationStep', 'subTitle')}</p>
        </div>
        <div className="grid-inner-content mz-confirmation-step-basa__callout">
          <CalloutBoxShort
            vehicleData={vehicleData}
            dealerData={dealer as any}
            userPosition={userPosition}
            dateAndTimeData={dateAndTimeData ? {
              date: dateAndTimeData.date.toISOString().split('T')[0],
              time: dateAndTimeData.time
            } : undefined}
            isOwnVehicleType={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationStep;
